import {
  atom
} from 'recoil';

export const websiteDataState = atom({
  key: 'websiteDataState', // unique ID (with respect to other atoms/selectors)
  default: {}, // default value (aka initial value)
});